import React from 'react'
import { Observable } from 'rxjs'
import { AjaxResponse } from 'rxjs/ajax'
import { getInvoiceRegister } from 'utils/api-routes-accounts'
import ReportTablePage from './ReportTablePage'
import { useFinanceObservable } from '../../hooks/useFinanceObservable'
import { FinanceApiResponse } from '../../types/finance'
import formatFinanceDate from '../../utils/formatFinanceDate'

const InvoiceRegister = () => {
  const report = useFinanceObservable<any[]>(
    () =>
      getInvoiceRegister({}) as any as Observable<
        AjaxResponse<FinanceApiResponse<any[]>>
      >,
  )

  return (
    <ReportTablePage
      title="Invoice Register"
      isLoading={report.loading}
      rows={report.data || []}
      columns={[
        { name: 'Number', selector: (row) => row.number || `INV-${row.id}` },
        { name: 'Type', selector: (row) => row.document_type || '--' },
        {
          name: 'Partner',
          selector: (row) => row.partner_name || row.partner?.name || '--',
        },
        {
          name: 'Document Date',
          selector: (row) => formatFinanceDate(row.document_date),
        },
        {
          name: 'Due Date',
          selector: (row) => formatFinanceDate(row.due_date),
        },
        { name: 'Total', selector: (row) => row.amount_total ?? '--' },
        { name: 'Residual', selector: (row) => row.amount_residual ?? '--' },
        { name: 'State', selector: (row) => row.state || '--' },
      ]}
    />
  )
}

export default InvoiceRegister
